// Supreme Laboratories heraldic logo - uses generated brand image
export default function Logo({ size = "md", showText = true, className = "" }) {
  const sizes = {
    sm: { img: "h-9 w-9", brand: "text-xs", sub: "text-[8px]" },
    md: { img: "h-12 w-12", brand: "text-base", sub: "text-[10px]" },
    lg: { img: "h-16 w-16", brand: "text-xl", sub: "text-[11px]" },
    xl: { img: "h-24 w-24", brand: "text-2xl", sub: "text-xs" },
  };
  const s = sizes[size] || sizes.md;
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <img
        src="/brand/logo.png"
        alt="Supreme Laboratories"
        className={`${s.img} object-contain shrink-0`}
        style={{ mixBlendMode: "lighten", filter: "drop-shadow(0 0 12px rgba(239, 68, 68, 0.25))" }}
      />
      {showText && (
        <div className="leading-none">
          <div
            className={`font-headline font-black tracking-tight text-white ${s.brand}`}
            style={{ letterSpacing: "0.08em" }}
          >
            SUPREME
          </div>
          <div
            className={`font-headline font-medium text-zinc-400 mt-1 ${s.sub}`}
            style={{ letterSpacing: "0.35em" }}
          >
            LABORATORIES
          </div>
        </div>
      )}
    </div>
  );
}
